import appApi from '../../../../../../../api/app-api';
import { toast } from 'react-toastify';
import globalUserPage from '../../../../../../../stores/global-user-page';

export const processRefund = async (
  allocationId: number,
  userId: number,
  userPaymentId: number,
  userPaymentItemId: number,
  refundAmount: number,
  setLoading: (loading: boolean) => void,
): Promise<void> => {
  try {
    setLoading(true);

    await appApi.processPaymentRefund(
      allocationId,
      userId,
      userPaymentId,
      userPaymentItemId,
      -refundAmount,
    );
    // Refresh user details to get updated payment services
    const updatedUserDetails = await appApi.getUserStudentDetails(userId);
    globalUserPage.studentDetails = updatedUserDetails.data.body;

    // TODO add reload logic for the state§
    console.log('Refund processed successfully');
  } catch (error) {
    console.error('Error processing refund:', error);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
  } finally {
    setLoading(false);
  }
};
